// apps/admin/src/lib/header-search.js
//
// Header search-form handoff (Task 1.7; spec §3.1). The `.search` form
// (apps/admin/index.html, inside `.topbar`) is a persistent shell control —
// unlike a `[data-screen]` section it is never hidden/reused/torn down by
// the router — so it is wired ONCE at boot, the same way shell.js's
// initShell() binds the hamburger/scrim/Escape handlers once, rather than
// through the router's per-navigation ctx.onTeardown.
//
// Submitting hands the typed term to the existing first-party, same-origin
// Users search (apps/admin/src/screens/users.js) — no new endpoint, no
// cross-entity search: a non-empty (trimmed) term becomes `?search=<term>`
// on the Users screen; an empty (or whitespace-only) term just navigates to
// plain /admin/users.
export function initHeaderSearch(navigate, root = document) {
  const form = root.querySelector('#admin-search-form');
  const input = form?.querySelector('input[name="search"]');
  if (!form || !input) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const term = input.value.trim();
    navigate(term ? `/admin/users?search=${encodeURIComponent(term)}` : '/admin/users');
  });
}
